<template>
  <div class="loading-wrap" ref="loading">
    <div class="content-wrap">
      <div class="loading">
        <img v-lazy="require('@/assets/img/loading/tips.png')" class="tips" alt="">
        <!-- <img src="@/assets/img/loading/小孩子.png" class="img" alt=""> -->
        <div class="main">
          <img v-lazy="require('@/assets/img/main/男孩3.png')" class="loading1" alt="">
          <img v-lazy="require('@/assets/img/main/女孩2.png')" class="loading2" alt="">
          <img v-lazy="require('@/assets/img/main/男孩4.png')" class="loading3" alt="">
        </div>
        <div class="progress-box">
          <div class="progress" :style="{width:progress+'%'}"></div>
          <!-- <span>{{progress}}</span> -->
        </div>
        <div class="lottery-tips">全部找出来即可抽奖哟~</div>
      </div>
    </div>
  </div>
</template>

<script>
import LongTake from '@/utils/LongTake'
import { resources } from '@/assets/map'

export default {
  name: 'loading',
  data () {
    return {
      progress: 0
    }
  },
  methods: {
    async initLongTake() {
      if (this.longTake) {
        this.longTake.goToPosition(0)
        this.longTake.enableScroll = true
        await this.goTime(100)
        this.$router.push({ name: 'home', replace: true })
        return
      }
      const longTake = new LongTake({
        // container: this.$el,
        heigth: 750,
        resource: this.getResource(),
        // sprites: this.getSprites(),
        // spritesAnimations: this.getSpritesAnimations(),
        // texts: this.getTexts(),
        // textsAnimations: this.getTextsAnimations(),
        // touchOptions: { // 使用PhyTouch
        //   touch: '#app', // 反馈触摸dom
        //   value: 0, // 起始位置
        //   sensitivity: 0.8, // 不必需，触摸区域的灵敏度
        //   maxSpeed: 1 // 不必需，触摸反馈的最大速度限制
        // },
        vertical: false, // 横屏
        autoLoad: true
      })
      longTake.on('loadDone', async () => {
        console.log('加载成功')
        await this.goTime(100)
        this.$store.commit('activity/SET_LONG_TAKE', longTake)
        this.$router.push({ name: 'home', replace: true })
      })
      longTake.on('loadProgress', async (progress) => {
        // console.log(progress)
        await this.goTime(parseInt(progress))
      })
    },
    getResource() {
      console.log(resources)
      return { sprites: [...resources] }
    },
    /** 获取精灵图. */
    getSprites() {
      // 避免同名变量的冲突并深拷贝.
      return {}
    },
    /** 获取精灵动画 */
    getSpritesAnimations() {
      return []
    },
    /** 背景获取 */
    getBgSprites() {
    },
    /** 获取文本 */
    getTexts() {
      // Tips: 这里获取的是本地资源配置的文本，也可以通过接口获取远程资源.
      return []
    },
    /** 获取文本动画 */
    getTextsAnimations() {
      return []
    },
    init () {
      this.initLongTake()
    },
    goTime (percent) {
      return new Promise(resolve => {
        const timer = setInterval(() => {
          if (this.progress < percent && this.progress < 100) {
            this.progress++
          } else {
            clearInterval(timer)
            resolve()
          }
        }, 10)
      })
    }
  },
  created () {
    this.init()
  },
  mounted() {
    this.$parent.setDevice(this.$refs.loading)
  }
}
</script>

<style lang='scss' scoped>
.loading-wrap {
  background: url(~@/assets/img/loading/加载页bg.png) no-repeat;
  background-size: auto 100%;
  background-position: center 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .content-wrap {
    background: url(~@/assets/img/loading/色块.png) no-repeat;
    background-size: 100%;
    width: 1064px;
    height: 533px;
    padding: 86px 0 0;
  }
  .loading {
    text-align: center;
    .tips {
      width: 712px;
    }
    .img {
      width: 384px;
      margin: 20px auto 0;
    }
    .main {
      width: 384px;
      margin: 20px auto 0;
    }
    .loading1 {
      width: 100px;
      animation: jump1 1s linear infinite;
    }
    .loading2 {
      width: 110px;
      margin: 0 20px;
      transform: rotate(20deg);
      animation: jump2 1s 0.5s linear infinite;
    }
    .loading3 {
      width: 80px;
      top: 30px;
      margin-left: 20px;
      position: relative;
      transform: scaleX(-1);
      animation: jump3 1s 1s linear infinite;
    }
    @keyframes jump1 {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-20px);
      }
      10% {
        transform: translateY(0);
      }
    }
    @keyframes jump2 {
      0% {
        transform: translateY(0) rotate(20deg);
      }
      50% {
        transform: translateY(-20px) rotate(20deg);
      }
      10% {
        transform: translateY(0) rotate(20deg);
      }
    }
    @keyframes jump3 {
      0% {
        transform: translateY(0) scaleX(-1);
      }
      50% {
        transform: translateY(-20px) scaleX(-1);
      }
      10% {
        transform: translateY(0) scaleX(-1);
      }
    }
  }
  .lottery-tips {
    font-size: 24px;
    text-align: center;
    width: 100%;
    margin: 20px auto 0;
    color: #CB5547;
  }
  .progress-box {
    width:617px;
    height:18px;
    // background:rgba(253,249,219,1);
    border:2px solid #CB5547;
    border-radius:9px;
    margin: 0 auto;
    .progress {
      background: #F49F81;
      height:14px;
      border-radius:9px;
    }
  }
}
</style>
